export const NotFound: React.FC = () => {
  return (
    <div className="w-screen h-screen bg-gray-300 flex items-center justify-center">
      <h1 className="text-green-600 text-4xl md:text-7xl">404 Not Found</h1>
    </div>
  )
}
